import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function usernameOrPhoneInputValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.toString().trim();

    if (!value) {
      return { required: true };
    }

    const startsWithNumber = /^[0-9]/.test(value);

    if (startsWithNumber) {
      const isValidPhone = /^05[0-9]{8}$/.test(value);
      return isValidPhone ? null : { usernameOrPhone: true };
    } else {
      const isValidUsername = /^[a-z][a-z0-9_]{4,}$/.test(value);
      return isValidUsername ? null : { usernameOrPhone: true };
    }
  };
}
